import {relationGroupsConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { deleteRelationLoading : true, data: '', error: false};

export function deleteRelation(state = initialState, action) {
    switch (action.type) {
      case relationGroupsConstants.REQUEST_DELETE_RELATION:
        return {
          deleteRelationLoading: true,
          data: action.data,
          error: false
        };
      case relationGroupsConstants.RECEIVE_DELETE_RELATION:
      // swal({
      //   text: 'Relation Group deleted Successfully',
      //   type: 'success',
      //   confirmButtonColor: '#3085d6',
      //   confirmButtonText: 'OK'
      // })
        return {
          deleteRelationLoading: false,
          data: action.relation,
          error: false
        };
      case relationGroupsConstants.DELETE_RELATION_ERROR:
        return { 
          deleteRelationLoading: false,
          data: action.error,
          error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/relationGroups/deleteRelation.reducer.js